import { Required } from "components/Required";
import { Page } from "containers/Page";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useExtracaoXml } from "./hooks/useExtracaoXml";
import { IExtracaoXml } from "./interfaces/IExtracaoXml";
import { Button, ButtonEnviar } from "./style";

export function ExtracaoXml() {
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitted },
  } = useForm<IExtracaoXml>();

  const { loading, extrairXmls } = useExtracaoXml();

  function handleBaixarModelo() {
    const link = document.createElement("a");
    link.download = "Modelo_extrair_zip_xml.xlsx";
    link.href = "/app/files/Modelo_extrair_zip_xml.xlsx";
    link.click();
  }
  return (
    <Page lastPage="Home / Backoffice" title="Extração XML">
      <div className="bg-white">
        <Row className="p-4">
          <Col md={12}>
            <p>Faça o upload da planilha e do ZIP de XMLs</p>
            <div>
              <form onSubmit={handleSubmit(extrairXmls)}>
                <Row>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        XLS <Required />
                      </Form.Label>
                      <br />

                      <Controller
                        name="xlsFile"
                        control={control}
                        render={({ field: { onChange } }) => (
                          <input
                            type="file"
                            onChange={(event) => {
                              onChange(event.target.files?.[0]);
                            }}
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          />
                        )}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        ZIP de XMLs <Required />
                      </Form.Label>
                      <br />

                      <Controller
                        name="zipFile"
                        control={control}
                        render={({ field: { onChange } }) => (
                          <input
                            type="file"
                            onChange={(event) => {
                              onChange(event?.target?.files?.[0]);
                            }}
                            accept=".zip"
                          />
                        )}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={2}>
                    <ButtonEnviar disabled={loading}>
                      {loading ? "Carregando" : "Enviar"}{" "}
                    </ButtonEnviar>
                  </Col>
                  <Col md={2}>
                    <Button
                      outline
                      variante="primary"
                      type="button"
                      onClick={handleBaixarModelo}
                    >
                      Baixar modelo
                    </Button>
                  </Col>
                </Row>
              </form>
            </div>
          </Col>
          <Col lg={6}></Col>
        </Row>
      </div>
    </Page>
  );
}
